// /* eslint-disable no-var */
// import { useEffect, useState } from 'react';
// import ModalComponent from '@components/Modal/ModalComponent';
// import { Card, CardBody } from '@components/card/card';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
// import AddChartAccounts from './AddChartAccounts';
// import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
// import useGetChartAccountsList from '@hooks/Finance/useGetChartAccountsList';
// import Loading from '@components/Shared/Loader/Loading';

// const Index = () => {
//   const [selectedacount, setSelectedaccount] = useState<any>('');
//   const { t, i18n } = useTranslation();
//   const Navigate = useNavigate();
//   const { Chart, loading: loading2, error: error2 } = useGetChartAccountsDetailsList();
//   const { ChartAccountsList, loading, error } = useGetChartAccountsList();

//   console.log(JSON.stringify(Chart));

//   console.log(Chart.details);
  

//   const filteredSearch = Chart.details
//     ?.slice()
//     ?.filter(
//       f =>
//         f.accountParant === null &&
//         f.chartOfAccountsId?.toLowerCase() === selectedacount?.toLowerCase() &&
//         f.id !== 'f289092c-0842-4676-af1a-736df6388f1e' //"Future"
//     )
//     .sort((a, b) => a.sequenceNum - b.sequenceNum);

//   useEffect(() => {
//     setSelectedaccount(ChartAccountsList[0]?.id);
//   }, [ChartAccountsList]);

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: '/FINANCE/HomePage'
//           },
//           {
//             name: 'الدليل المحاسبي',
//             link: null
//           }
//         ]}
//         PageName='الدليل المحاسبي'
//       />
//       <hr />

//       <Loading loading={loading || loading2} error={error || error2}>
//         <CardBody>
//           <div className='p-2'>
//             <div className='row'>
//               {filteredSearch?.map((item, index) => (
//                 <div className='col-xl-4 col-md-6 mb-4' key={item.id}>
//                   <Card>
//                     <div
//                       className=' h-100 shadow-sm cursor-pointer'
//                       onClick={() => {
//                         if (item.accountType === 'Companies' && item.accountParant === null) {
//                           Navigate(`${item.id}/CompaniesAndBranches`);
//                         } else if (item.accountType === 'CostCenters' && item.accountParant === null) {
//                           Navigate(`${item.id}/CostCenters`);
//                         } else if (item.accountType === 'Accounts' && item.accountParant === null) {
//                           Navigate(`${item.id}/ChartAccountsDetails`);
//                         }
//                       }}
//                     >
//                       <div className='card-body text-center p-3'>
//                         <div className='icon-wrapper mb-3'>
//                           <i
//                             className={`
//                           fs-50px
//                             ${
//                               item.accountType === 'Companies' && item.accountParant === null
//                                 ? 'fas fa-building text-primary'
//                                 : item.accountType === 'CostCenters' && item.accountParant === null
//                                 ? 'fas fa-coins text-warning'
//                                 : item.accountType === 'Accounts' && item.accountParant === null
//                                 ? 'fas fa-calculator text-success'
//                                 : 'bi bi-menu-up text-secondary'
//                             }
//                           `}
//                           ></i>
//                         </div>
//                         <h5 className='card-title mb-1'>{i18n.language === 'ar' ? item.name2 : item.name}</h5>
//                         {/* <div className='badge bg-light text-dark mt-2'>{item.accountType}</div> */}
//                       </div>
//                     </div>
//                   </Card>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </CardBody>
//       </Loading>

//       <ModalComponent title='ChartAccounts' id='modalAddChartAccounts' size='lg'>
//         {<AddChartAccounts />}
//       </ModalComponent>

//       <style>
//         {`

//           .cursor-pointer {
//   cursor: pointer;
//   transition: all 0.3s ease;
// }

// .cursor-pointer:hover {
//   transform: translateY(-5px);
//   box-shadow: 0 10px 20px rgba(0,0,0,0.1);
// }

// .icon-wrapper {
//   width: 80px;
//   height: 80px;
//   margin: 0 auto;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0,0,0,0.03);
//   border-radius: 50%;
// }

// .card {
//   border: 1px solid rgba(0,0,0,0.1);
//   border-radius: 10px;
// }
//           `}
//       </style>
//     </>
//   );
// };

// export default Index;


// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------

/* eslint-disable no-var */
// import { useEffect, useState } from 'react';
// import ModalComponent from '@components/Modal/ModalComponent';
// import { Card, CardBody } from '@components/card/card';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
// import AddChartAccounts from './AddChartAccounts';
// import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
// import useGetChartAccountsList from '@hooks/Finance/useGetChartAccountsList';
// import Loading from '@components/Shared/Loader/Loading';

// const Index = () => {
//   const [selectedacount, setSelectedaccount] = useState<any>('');
//   const { t, i18n } = useTranslation();
//   const Navigate = useNavigate();
//   const { Chart, loading: loading2, error: error2 } = useGetChartAccountsDetailsList();
//   const { ChartAccountsList, loading, error } = useGetChartAccountsList();

//   console.log(JSON.stringify(Chart));

//   const filteredSearch = Chart.details
//     ?.slice()
//     ?.filter(
//       f =>
//         f.accountParant === null &&
//         f.chartOfAccountsId?.toLowerCase() === selectedacount?.toLowerCase() &&
//         f.id !== 'f289092c-0842-4676-af1a-736df6388f1e' //"Future"
//     )
//     .sort((a, b) => a.sequenceNum - b.sequenceNum);

//   // ✅ جلب جذور الأنواع الثلاثة فقط
//   const companiesRoot = filteredSearch?.find(
//     x => x.accountType === 'Companies' && x.accountParant === null
//   );
//   const costCentersRoot = filteredSearch?.find(
//     x => x.accountType === 'CostCenters' && x.accountParant === null
//   );
//   const accountsRoot = filteredSearch?.find(
//     x => x.accountType === 'Accounts' && x.accountParant === null
//   );

//   const cards = [
//     {
//       key: 'Companies',
//       item: companiesRoot,
//       icon: 'fas fa-building text-primary',
//       route: 'CompaniesAndBranches',
//       fallbackAr: 'الشركات والفروع',
//       fallbackEn: 'Companies & Branches'
//     },
//     {
//       key: 'CostCenters',
//       item: costCentersRoot,
//       icon: 'fas fa-coins text-warning',
//       route: 'CostCenters',
//       fallbackAr: 'مراكز التكلفة',
//       fallbackEn: 'Cost Centers'
//     },
//     {
//       key: 'Accounts',
//       item: accountsRoot,
//       icon: 'fas fa-calculator text-success',
//       route: 'ChartAccountsDetails',
//       fallbackAr: 'الحسابات',
//       fallbackEn: 'Accounts'
//     }
//   ];

//   useEffect(() => {
//     setSelectedaccount(ChartAccountsList[0]?.id);
//   }, [ChartAccountsList]);

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: '/FINANCE/HomePage'
//           },
//           {
//             name: 'الدليل المحاسبي',
//             link: null
//           }
//         ]}
//         PageName='الدليل المحاسبي'
//       />
//       <hr />

//       <Loading loading={loading || loading2} error={error || error2}>
//         <CardBody>
//           <div className='p-2'>
//             <div className='row'>
//               {cards.map(c => {
//                 const title =
//                   c.item != null
//                     ? i18n.language === 'ar'
//                       ? c.item.name2
//                       : c.item.name
//                     : i18n.language === 'ar'
//                     ? c.fallbackAr
//                     : c.fallbackEn;

//                 return (
//                   <div className='col-xl-4 col-md-6 mb-4' key={c.key}>
//                     <Card>
//                       <div
//                         className={`h-100 shadow-sm ${c.item ? 'cursor-pointer' : 'opacity-50'}`}
//                         onClick={() => {
//                           if (!c.item) return;
//                           Navigate(`${c.item.id}/${c.route}`);
//                         }}
//                       >
//                         <div className='card-body text-center p-3'>
//                           <div className='icon-wrapper mb-3'>
//                             <i className={`fs-50px ${c.icon}`}></i>
//                           </div>

//                           <h5 className='card-title mb-1'>{title}</h5>

//                           {!c.item && (
//                             <div className='text-muted small mt-2'>
//                               {i18n.language === 'ar' ? 'غير متوفر في الدليل' : 'Not available in chart'}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </Card>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </CardBody>
//       </Loading>

//       <ModalComponent title='ChartAccounts' id='modalAddChartAccounts' size='lg'>
//         {<AddChartAccounts />}
//       </ModalComponent>

//       <style>
//         {`
//           .cursor-pointer {
//             cursor: pointer;
//             transition: all 0.3s ease;
//           }

//           .cursor-pointer:hover {
//             transform: translateY(-5px);
//             box-shadow: 0 10px 20px rgba(0,0,0,0.1);
//           }

//           .icon-wrapper {
//             width: 80px;
//             height: 80px;
//             margin: 0 auto;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             background: rgba(0,0,0,0.03);
//             border-radius: 50%;
//           }

//           .card {
//             border: 1px solid rgba(0,0,0,0.1);
//             border-radius: 10px;
//           }
//         `}
//       </style>
//     </>
//   );
// };

// export default Index;


/* eslint-disable no-var */
import { useEffect, useState } from 'react';
import ModalComponent from '@components/Modal/ModalComponent';
import { Card, CardBody } from '@components/card/card';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AddChartAccounts from './AddChartAccounts';
import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
import useGetChartAccountsList from '@hooks/Finance/useGetChartAccountsList';
import Loading from '@components/Shared/Loader/Loading';
import ChartAccountsConfigModal from './ChartAccountsConfigModal';

 
const Index = () => {
  const [selectedacount, setSelectedaccount] = useState<any>('');
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();

  const { Chart, loading: loading2, error: error2 } = useGetChartAccountsDetailsList();
  const { ChartAccountsList, loading, error } = useGetChartAccountsList();

  // console.log(JSON.stringify(Chart));

  const filteredSearch = Chart.details
    ?.slice()
    ?.filter(
      f =>
        f.accountParant === null &&
        f.chartOfAccountsId?.toLowerCase() === selectedacount?.toLowerCase() &&
        f.id !== 'f289092c-0842-4676-af1a-736df6388f1e' //"Future"
    )
    .sort((a, b) => a.sequenceNum - b.sequenceNum);

  // ✅ الجذور الثلاثة
  const companiesRoot = filteredSearch?.find(x => x.accountType === 'Companies' && x.accountParant === null);
  const costCentersRoot = filteredSearch?.find(x => x.accountType === 'CostCenters' && x.accountParant === null);
  const accountsRoot = filteredSearch?.find(x => x.accountType === 'Accounts' && x.accountParant === null);

  const cards = [
    {
      key: 'Companies',
      item: companiesRoot,
      icon: 'fas fa-building text-primary',
      route: 'CompaniesAndBranches',
      fallbackAr: 'الشركات والفروع',
      fallbackEn: 'Companies & Branches'
    },
    {
      key: 'CostCenters',
      item: costCentersRoot,
      icon: 'fas fa-coins text-warning',
      route: 'CostCenters',
      fallbackAr: 'مراكز التكلفة',
      fallbackEn: 'Cost Centers'
    },
    {
      key: 'Accounts',
      item: accountsRoot,
      icon: 'fas fa-calculator text-success',
      route: 'ChartAccountsDetails',
      fallbackAr: 'الحسابات',
      fallbackEn: 'Accounts'
    }
  ];

  useEffect(() => {
    setSelectedaccount(ChartAccountsList?.[0]?.id);
  }, [ChartAccountsList]);

  // ✅ مودال الإعداد
  const [showConfigModal, setShowConfigModal] = useState(false);

  const handleConfigured = () => {
    // بعد نجاح الإعداد افتح شاشة الحسابات
    if (accountsRoot?.id) {
      Navigate(`${accountsRoot.id}/ChartAccountsDetails`);
    }
  };

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          { name: 'Home', link: '/FINANCE/HomePage' },
          { name: 'الدليل المحاسبي', link: null }
        ]}
        PageName='الدليل المحاسبي'
      />
      <hr />

      <Loading loading={loading || loading2} error={error || error2}>
        <CardBody>
          <div className='p-2'>
            <div className='row'>
              {cards.map(c => {
                const title =
                  c.item != null
                    ? i18n.language === 'ar'
                      ? c.item.name2
                      : c.item.name
                    : i18n.language === 'ar'
                    ? c.fallbackAr
                    : c.fallbackEn;

                return (
                  <div className='col-xl-4 col-md-6 mb-4' key={c.key}>
                    <Card>
                      <div
                        className={`h-100 shadow-sm ${c.item ? 'cursor-pointer' : 'opacity-50'}`}
                        onClick={() => {
                          if (!c.item) return;

                          // ✅ إذا Accounts و غير مهيأ افتح المودال بدل التنقل
                          // if (c.key === 'Accounts' && Chart?.isConfigured === false) {
                          if (c.key === 'Accounts' && Chart?.isConfigured === true) {
                            setShowConfigModal(true);
                            return;
                          }

                          Navigate(`${c.item.id}/${c.route}`);
                        }}
                      >
                        <div className='card-body text-center p-3'>
                          <div className='icon-wrapper mb-3'>
                            <i className={`fs-50px ${c.icon}`}></i>
                          </div>

                          <h5 className='card-title mb-1'>{title}</h5>

                          {!c.item && (
                            <div className='text-muted small mt-2'>
                              {i18n.language === 'ar' ? 'غير متوفر في الدليل' : 'Not available in chart'}
                            </div>
                          )}

                          {/* {c.key === 'Accounts' && Chart?.isConfigured === false && ( */}
                          {c.key === 'Accounts' && Chart?.isConfigured === true && (
                            <div className='text-muted small mt-2'>
                              {i18n.language === 'ar' ? 'غير مُهيأ - اضغط للإعداد' : 'Not configured - click to setup'}
                            </div>
                          )}
                        </div>
                      </div>
                    </Card>
                  </div>
                );
              })}
            </div>
          </div>
        </CardBody>
      </Loading>

      {/* مودال الإضافة القديم */}
      <ModalComponent title='ChartAccounts' id='modalAddChartAccounts' size='lg'>
        {<AddChartAccounts />}
      </ModalComponent>

      {/* ✅ مودال إعداد الدليل المحاسبي (مكون منفصل) */}
      <ChartAccountsConfigModal
        show={showConfigModal}
        onHide={() => setShowConfigModal(false)}
        chartOfAccountsId={selectedacount}
        configEndpoint={''}
        onConfigured={handleConfigured}
      />

      <style>
        {`
          .cursor-pointer {
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .cursor-pointer:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0,0,0,0.1);
          }

          .icon-wrapper {
            width: 80px;
            height: 80px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0,0,0,0.03);
            border-radius: 50%;
          }

          .card {
            border: 1px solid rgba(0,0,0,0.1);
            border-radius: 10px;
          }
        `}
      </style>
    </>
  );
};

export default Index;
